/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import { Select, Spin } from "antd";
import { useEffect, useState } from "react";

function FetchSelect({
  elementFetcher,
  searchParam,
  extraParams,
  labelShow,
  elementNameToSave,
  initialLabel,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [elements, setElements] = useState([]);
  const [label, setLabel] = useState(localStorage.getItem(elementNameToSave));

  useEffect(() => {
    if (!label && elementNameToSave) return;

    localStorage.setItem("company", label);
  }, [label]);

  useEffect(() => {
    if (!label && elementNameToSave) return;

    setFetching(true);

    elementFetcher({ ...extraParams }).then((response) => {
      setElements(response.results);
      setFetching(false);
    });
  }, []);

  const processedOptions = elements.map(element => ({
    ...element,
    label: labelShow ? labelShow(element) : element.label || element.name,
    value: element.id
  }));

  return (
    <Select
      showSearch
      labelInValue={true}
      options={processedOptions}
      filterOption={(input, option) => {
        if (!input) return true;
        return option.label?.toLowerCase().includes(input.toLowerCase());
      }}
      notFoundContent={
        fetching ? (
          <Spin size="small" />
        ) : (
          "No encontramos elementos con ese nombre"
        )
      }
      labelRender={(props) => props.label}
      optionRender={(props) => props.label}
      placeholder="Elige una empresa"
      {...props}
    />
  );
}

export default FetchSelect;
